// extracted by mini-css-extract-plugin
export default {"list":"HeaderMenu_list__aAneu","link":"HeaderMenu_link__uuJ5e"};